import { Module } from 'vuex';
import comparatorRepository from '@/repositories/comparatorRepository';
import queryLib from '@/library/queryLib';
import { RootState } from './types';

type SchoolType = 'default' | 'po' | 'vo';

export type Comparator = 'Geen vergelijking' | 'rendement' | 'ouderbijdrage' | 'schoolgidsen'
  | 'schoolplannen' | 'artikelen' | 'examencijfers' | 'bijzonderheden' | 'onderwijsconcept'
  | 'slagingspercentages' | 'video' | 'inspectieoordeel' | 'tevredenheid' | 'vmbo_profielen';

export type ComparatorState = {
  currentComparator: Comparator;
  comparatorsBySchoolType: {
    default: Comparator[];
    po: Comparator[];
    vo: Comparator[];
  };
}

const { COMPARATORS, DEFAULT_COMPARATOR } = comparatorRepository;

export default {
  namespaced: true,
  state: {
    comparatorsBySchoolType: COMPARATORS,
    currentComparator: getInitialComparator(),
  },
  getters: {
    comparatorOptionsBySchoolType(state) {
      return (schoolType: 'default' | 'po' | 'vo') => {
        if (['default', 'po', 'vo'].includes(schoolType)) {
          return state.comparatorsBySchoolType[schoolType];
        }
        return state.comparatorsBySchoolType.default;
      };
    },
    comparatorOptions(state, getters, rootState, rootGetters) {
      const currentSchoolTypeFilter = (rootGetters['filter/typeValue'] || 'default') as SchoolType;
      const comparatorOptions = getters.comparatorOptionsBySchoolType(currentSchoolTypeFilter);
      return comparatorOptions.sort((a: Comparator, b: Comparator) => {
        if (a === DEFAULT_COMPARATOR) {
          return -1;
        }
        if (a < b) {
          return -1;
        }
        return 1;
      });
    },
    currentComparator(state) {
      return state.currentComparator;
    },
  },
  mutations: {
    setCurrentComparator(state, comparator: Comparator) {
      state.currentComparator = comparator;
      queryLib.addQueryParams({ comparator });
    },
  },
  actions: {
    evaluateCurrentComparator({ getters, commit }) {
      const options = getters.comparatorOptions;
      const current = getters.currentComparator;

      if (!options.includes(current)) {
        commit('setCurrentComparator', DEFAULT_COMPARATOR);
      }
    },
  },
} as Module<ComparatorState, RootState>;

function getInitialComparator() {
  const queryParams = queryLib.getQueryParams();
  return 'comparator' in queryParams ? queryParams.comparator : DEFAULT_COMPARATOR;
}
